<template>
    <div>
        <el-drawer title="绑定用户" :visible.sync="isShow" size="900px" @close="$emit('close')">
            <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch" label-width="90px">
                <el-form-item label="预定人" prop="contact">
                    <el-input v-model="searchForm.contact" placeholder="预定人" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="searchForm.phone" placeholder="手机号" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                    <el-button @click="handleReset" size="small">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="padding-bottom: 10px">
                <el-button icon="el-icon-plus" type="primary" size="small" @click="handleAdd">新增</el-button>
            </div>
            <div class="order_info">
                <b>已授信预定人数: <span>{{tableDataTotal.peopleCount}}</span></b>
                <b>已授信总额度: <span>¥{{tableDataTotal.totalCredit || 0}}</span></b>
                <b>可用授信总额度: <span>¥{{tableDataTotal.creditAmount || 0}}</span></b>
            </div>
            <el-table border size="small" style="width: 100%; margin-top: 10px" :data="tableData" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column type="index" label="#" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
                <el-table-column prop="contact" label="预定人" width="120"></el-table-column>
                <el-table-column prop="phone" label="手机号码" width="120"></el-table-column>
                <el-table-column prop="totalCredit" label="授信额度" width="120"></el-table-column>
                <el-table-column prop="creditAmount" label="可用额度" width="120"></el-table-column>
                <el-table-column prop="type" label="结算类型" width="120">
                    <template slot-scope="{ row }">
                        <el-tag type="success" size="mini" v-if="row.type == 1">月结</el-tag>
                        <el-tag type="danger" size="mini" v-else>信用额度</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" width="120"></el-table-column>
                <el-table-column label="操作" fixed="right" align="center" width="150">
                    <template slot-scope="{ row }">
                        <el-button size="mini" type="text" @click="handleEdit(row)">修改</el-button>
                        <el-button size="mini" type="text" style="color: #409eff" @click="handleOrderDetail(row)">账单明细</el-button>
                        <el-button size="mini" type="text" style="color: red" @click="handleDelete(row)">解除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage" style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total"></el-pagination>
        </el-drawer>

        <el-dialog :visible.sync="isAdd" :title="!modelForm.id ? '添加关联用户' : '编辑关联用户'" width="520px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="warn-tips">
                <i class="el-icon-info"></i>
                <div>
                    <span>1.添加支持企业订房的手机号。</span>
                    <span>2.支持信用额度消费、企业订单挂帐。</span>
                </div>
            </div>
            <el-form ref="modelForm" :model="modelForm" label-width="110px" style="margin: 0 20px" size="small" :rules="modelFormRules">
                <el-form-item label="预定人" prop="contact">
                    <el-input type="text" v-model="modelForm.contact" placeholder="请输入预定人" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input type="text" v-model="modelForm.phone" placeholder="请输入预定人手机号" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="结算类型" prop="type">
                    <el-select v-model="modelForm.type" placeholder="结算类型" style="width: 240px">
                        <el-option label="信用额度" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="totalCredit" v-if="modelForm.type == 0">
                    <template slot="label">
                        <span>信用额度</span>
                        <el-tooltip class="item" effect="dark" content="授权信用消费额度，可先消费后对账，达到信用额度上限或未完成结算的企业将无法继续预订。" placement="top-start">
                            <i style="color: #C8C9CC;font-size: 18px;" class="el-icon-question"></i>
                        </el-tooltip>
                    </template>
                    <el-input v-model="modelForm.totalCredit" placeholder="请输入信用额度" clearable style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="text" v-model="modelForm.remark" placeholder="备注(选填)" style="width: 240px"></el-input>
                </el-form-item>
            </el-form>
            <div class="footer" style="margin: 0 20px; text-align: right">
                <el-button type="text" @click="isAdd = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-dialog>
        <OrderDetail :isOrderDetail.sync="isOrderDetail" :enterpriseId="enterpriseId" :propData="propData"></OrderDetail>
    </div>
</template>


<script>
import { deepClone } from '@/utils/util'
import OrderDetail from '../orderDetail/index.vue'
export default {
    props: {
        isBindUser: {
            type: Boolean,
            default: false,
        },
        hotelId: {
            type: String,
            default: null,
        },
        enterpriseId: {
            type: String,
            default: ''
        }
    },
    components: {
        OrderDetail
    },
    computed: {
        headers() {
            return {
                Authorization: localStorage.getItem("Token"),
            };
        },
    },
    data() {
        const validateContact = (rule, value, callback) => {
            if (!value || value.length > 10) {
                callback(new Error('预定人不能为空且长度最多10位'));
            } else if (/[^a-zA-Z0-9\_\u4e00-\u9fa5]/.test(value)) {
                callback(new Error('联系人不能输入非法字段'));
            } else {
                callback();
            }
        };
        const validateCredit = (rule, value, callback) => {
            if (!value || value <= 0 || !/^\d+(\.\d{1,2})?$/.test(value)) {
                callback(new Error("信用额度只能大于0且只能保留两位小数"));
            } else {
                callback();
            }
        };
        return {
            isOrderDetail: false,
            isShow: false,
            propData: {

            },
            searchForm: {
                contact: "",
                hotelId: this.hotelId,
                pageNumber: 1,
                pageSize: 10,
            },
            isLoading: false,
            tableData: [],
            tableDataTotal: {},
            total: 0,
            selectTime: [],
            isAdd: false,
            modelForm: {
                contact: '',
                phone: '',
                type: 0,
                totalCredit: '',
                remark: ''
            },
            modelFormRules: {
                phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的手机号', trigger: 'blur' }],
                contact: [{ required: true, validator: validateContact, trigger: "blur" }],
                type: [{ required: true, message: "请选择结算类型", trigger: "change" }],
                totalCredit: [{ required: true, validator: validateCredit, trigger: "change" }],
            },
            imgUrl: "",
            submitLoading: false,
        };
    },
    watch: {
        isBindUser(newVal) {
            this.isShow = !!newVal;
            if (!!newVal) {
                this.searchForm = {
                    contact: "",
                    phone: '',
                    pageNumber: 1,
                    pageSize: 10,
                };
                this.getTableData();
                this.getTableTotal();
            }
        },
    },
    methods: {
        handleOrderDetail(row) {
            const { phone } = row;
            this.propData = {
                phone
            }
            this.$nextTick(() => {
                this.isOrderDetail = true
            })
        },
        handleSubmit(fromName) {
            this.$refs[fromName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    this.modelForm.hotelId = this.hotelId;
                    if (!this.modelForm.id) {
                        this.postRequest("/enterpriseUser/addEnterpriseUser", this.modelForm)
                            .then((res) => {
                                this.submitLoading = false;
                                let data = res.data;
                                if (data.code == 200) {
                                    this.$message.success(data.msg);
                                    this.isAdd = false;
                                    this.getTableData();
                                    this.getTableTotal();
                                }
                            })
                            .catch(() => {
                                this.submitLoading = false;
                            });
                    } else {
                        this.putRequest("/enterpriseUser/editEnterpriseUser", this.modelForm)
                            .then((res) => {
                                this.submitLoading = false;
                                let data = res.data;
                                if (data.code == 200) {
                                    this.$message.success(data.msg);
                                    this.isAdd = false;
                                    this.getTableData();
                                    this.getTableTotal();
                                }
                            })
                            .catch(() => {
                                this.submitLoading = false;
                            });
                    }
                }
            });
        },
        handleAdd() {
            this.modelForm = {
                enterpriseId: this.enterpriseId,
                contact: '',
                phone: '',
                type: 0,
                totalCredit: '',
                remark: ''
            };
            this.isAdd = true;
            this.$nextTick(() => {
                this.$refs.modelForm.clearValidate()
            })
        },
        handleEdit(row) {
            this.modelForm = deepClone(row);
            this.isAdd = true
        },
        handleDelete(item) {
            this.$confirm("确定将选择数据解绑?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.deleteRequest(`/enterpriseUser/deleteCredit?id=${item.id}`).then((res) => {
                    let data = res.data;
                    if (data.code == 200) {
                        this.$message.success("解绑成功");
                        this.getTableData();
                        this.getTableTotal();
                    }
                });
            });
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                enterpriseId: this.enterpriseId,
                contact: "",
                phone: '',
                pageSize: 10,
                pageNumber: 1,
            };
            this.getTableData();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableTotal() {
            this.getRequest("/enterpriseUser/getSumStat", { enterpriseId: this.enterpriseId }).then((res) => {
                let data = res.data;
                if (data.code == 200) {
                    this.tableDataTotal = data.data;
                }
            });
        },
        getTableData() {
            this.isLoading = true;
            this.searchForm.enterpriseId = this.enterpriseId
            this.getRequest("/enterpriseUser/getPage", this.searchForm).then((res) => {
                let data = res.data;
                this.isLoading = false;
                if (data.code == 200) {
                    this.tableData = data.data.records;
                    this.total = data.data.total;
                }
            });
        },

    },
};
</script>

<style lang="less">
.warn-tips {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    background-color: #eeeeee;
    margin-bottom: 10px;
    font-size: 12px;
}

.warn-tips i {
    font-size: 20px;
    color: #409eff;
    margin-right: 5px;
}
.order_info {
    background: #ebf1ff;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    padding: 0px 12px;
    > b {
        font-weight: normal;
        margin-right: 50px;
        > span {
            color: #61acff;
        }
    }
}
</style>